import browser from '@openclassrooms/utils/browser';

export default {
  get: () => browser.window.PubSub,
};
